import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available

        const excludedUrls = [
            '/serviceEndpoint/getEndpoints'
        ];

        // Check if current request should skip token
        const shouldSkip = excludedUrls.some(url => request.url.includes(url));

        if (shouldSkip) {
            // Don’t attach token for these endpoints
            return next.handle(request);
        }
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.token) {
            let parsedToken = this.parseJwt(currentUser.token);
            if (!this.isTokenExpired(parsedToken.exp)) {
                request = request.clone({
                    setHeaders: { 
                        Authorization: `Bearer ${currentUser.token}`
                    }
                });
            }
            
        }
        return next.handle(request);
    }

    parseJwt(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    }

    isTokenExpired(exp: number): boolean {
        const currentTime = Math.floor(Date.now() / 1000); // Current time in epoch format (seconds)
        return currentTime >= exp;
    }
}